<script setup lang="ts">
import type { RouteLocationNamedRaw } from 'vue-router'

import SidebarLink from '~/components/atoms/SidebarLink.vue'

const route = useRoute()
const currentRouteName = computed(() => route.name?.toString())
const isActiveMenu = (name: string) => {
  if (!currentRouteName.value) return false
  const currentParts = currentRouteName.value.split('-')
  const nameParts = name.split('-')
  return currentParts.slice(0, 4).every((part, i) => part === nameParts[i])
}

defineProps<{
  title: string
  menus: { to: RouteLocationNamedRaw; text: string }[]
}>()
</script>

<template>
  <p class="sidebar-menu-title">{{ title }}</p>
  <ul class="sidebar-menu-list">
    <li
      v-for="(menu, i) in menus"
      :key="i"
      class="sidebar-menu-item sub"
      :class="{ active: isActiveMenu(menu.to.name?.toString() ?? '') }"
    >
      <SidebarLink :to="menu.to" :text="menu.text" />
    </li>
  </ul>
</template>

<style scoped lang="scss">
.sidebar-menu-title {
  font-size: 1rem;
  padding: 16px 0 8px 24px;
}
.sidebar-menu-list {
  padding: 8px 0px;
  .sidebar-menu-item {
    border-left: 4px solid transparent;
    a {
      display: block;
      color: var(--semantic-tokens-neutral-default-text);
      padding: 8px;
    }
    &.sub {
      a {
        padding-left: 40px;
      }
    }
    &:not(.active):hover {
      background-color: var(--semantic-tokens-neutral-xweak-surface);
    }
  }
  .active {
    background-color: var(--semantic-tokens-brand-weak-surface);
    border-left: 4px solid var(--semantic-tokens-brand-strong-border);
    a {
      font-weight: bold;
      color: var(--semantic-tokens-brand-strong-text);
    }
  }
}
</style>
